import { render, staticRenderFns } from "./RenameLayoutModal.vue?vue&type=template&id=7ae21d74&scoped=true"
import script from "./RenameLayoutModal.vue?vue&type=script&lang=js"
export * from "./RenameLayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae21d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae21d74')) {
      api.createRecord('7ae21d74', component.options)
    } else {
      api.reload('7ae21d74', component.options)
    }
    module.hot.accept("./RenameLayoutModal.vue?vue&type=template&id=7ae21d74&scoped=true", function () {
      api.rerender('7ae21d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/RenameLayoutModal.vue"
export default component.exports